"use client";

import React, { useState, useRef, useEffect } from "react";

export default function Leads({ data = null }) {
  let bgColor = 'bg-blue-700';
  let textColor = 'text-white';
  let text1 = 'Pronto para simplificar sua contabilidade?';
  let text2 = 'Conte com a LG Centro Contábil para cuidar de toda a parte burocrática enquanto você cuida do seu sucesso!';

  if(data) {
    bgColor = '';
    textColor = 'text-blue-700';
    text1 = data.contentField1 || '';
    text2 = data.contentField2 || '';
  }

  // dropdown 1
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(
    "Escolha o setor que deseja conversar"
  );
  const dropdownRef = useRef(null);
  const options = [
    "Contabilidade",
    "Consultoria",
    "Outro"
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // dropdown 1
  const [dropdownOpen2, setDropdownOpen2] = useState(false);
  const [selectedOption2, setSelectedOption2] = useState(
    "Como prefere nosso retorno?"
  );
  const dropdownRef2 = useRef(null);
  const options2 = [
    "Prefiro via Telefone",
    "Prefiro via Whatsapp",
    "Prefiro via E-mail"
  ];

  useEffect(() => {
    const handleClickOutside2 = (event) => {
      if (dropdownRef2.current && !dropdownRef2.current.contains(event.target)) {
        setDropdownOpen2(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside2);
    return () => document.removeEventListener("mousedown", handleClickOutside2);
  }, []);

  return (
    <section className={`w-full ${bgColor} h-auto md:h-[600px] py-16 px-4`}>
      <div className="w-full max-w-[1440px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        {/* Texto principal */}
        <div className={`flex flex-col justify-center ${textColor} text-center md:text-left`}>
          <h2 className="text-[36px] sm:text-[45px] md:text-[50px] font-normal mb-4">
            { text1 }
          </h2>
          <p className="text-[16px] sm:text-[18px] md:text-[20px] font-normal leading-snug">
            { text2 }
          </p>
        </div>

        {/* Formulário */}
        <div className="bg-[#ecf0f1] rounded-2xl p-8 shadow-lg w-full">
          <div className="flex flex-col items-center w-full">
            <h3 className="text-blue-700 text-[24px] sm:text-[28px] md:text-[32px] font-semibold mb-6 text-center">
              Fale Conosco
            </h3>

            <form className="w-full flex flex-col gap-4">
              <input
                type="text"
                placeholder="Informe seu nome"
                className="bg-white text-blue-700 w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-700"
              />
              <input
                type="tel"
                placeholder="Informe seu telefone"
                className="bg-white text-blue-700 w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-700"
              />
              <input
                type="email"
                placeholder="Informe seu e-mail"
                className="bg-white text-blue-700 w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-700"
              />

              {/* Dropdown customizado */}
              <div className="relative w-full" ref={dropdownRef}>
                <button
                  type="button"
                  className="w-full text-left px-4 py-3 rounded-lg border border-gray-300 bg-white flex justify-between items-center text-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-700"
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                >
                  {selectedOption}
                  <span
                    className={`transition-transform duration-300 ${
                      dropdownOpen ? "rotate-180" : "rotate-0"
                    }`}
                  >
                    ▼
                  </span>
                </button>
                {dropdownOpen && (
                  <ul className="absolute z-10 mt-1 w-full bg-white rounded-lg shadow-lg max-h-60 overflow-auto text-blue-700 text-base sm:text-lg">
                    {options.map((opt, idx) => (
                      <li
                        key={idx}
                        className="px-4 py-3 cursor-pointer hover:bg-blue-100"
                        onClick={() => {
                          setSelectedOption(opt);
                          setDropdownOpen(false);
                        }}
                      >
                        {opt}
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              {/* Dropdown customizado */}
              <div className="relative w-full" ref={dropdownRef2}>
                <button
                  type="button"
                  className="w-full text-left px-4 py-3 rounded-lg border border-gray-300 bg-white flex justify-between items-center text-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-700"
                  onClick={() => setDropdownOpen2(!dropdownOpen2)}
                >
                  {selectedOption2}
                  <span
                    className={`transition-transform duration-300 ${
                      dropdownOpen2 ? "rotate-180" : "rotate-0"
                    }`}
                  >
                    ▼
                  </span>
                </button>
                {dropdownOpen2 && (
                  <ul className="absolute z-10 mt-1 w-full bg-white rounded-lg shadow-lg max-h-60 overflow-auto text-blue-700 text-base sm:text-lg">
                    {options2.map((opt, idx) => (
                      <li
                        key={idx}
                        className="px-4 py-3 cursor-pointer hover:bg-blue-100"
                        onClick={() => {
                          setSelectedOption2(opt);
                          setDropdownOpen2(false);
                        }}
                      >
                        {opt}
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              <label className="flex items-center gap-2 text-gray-700 text-sm">
                <input type="checkbox" className="w-4 h-4 accent-blue-700" />
                Aceito receber e-mails com informações do setor contábil.
              </label>
              <button
                type="submit"
                className="bg-blue-700 hover:bg-blue-800 text-white font-semibold px-6 py-3 rounded-lg shadow-lg hover:shadow-xl transition duration-300"
              >
                Enviar
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
